import type { ComponentsUsingTool } from '@reach/shared-types/agent-components';
import { partnerApi, type ApiResponse } from '../../../lib/api';

export const toolComponentKeys = {
  all: ['tool-components'] as const,
  list: (toolId: string) => [...toolComponentKeys.all, toolId] as const,
} as const;

export async function fetchComponentsUsingTool(toolId: string): Promise<ComponentsUsingTool> {
  const response = await partnerApi.request<ApiResponse<ComponentsUsingTool>>(
    `/partner/tool-definitions/${toolId}/components`,
  );
  return response.data;
}
